//
// cookie-acceptance.js - helper to get & set cookie acceptance state
//


import {get_cookie, set_cookie} from './crumblr';


const DURATION = 182;
const ACCEPTED = 'Y';
const REJECTED = 'N';

function cookie_group_status_object(cookie_name) {
  return {
    is_accepted:      () => get_cookie(cookie_name) === ACCEPTED,
    is_rejected:      () => get_cookie(cookie_name) === REJECTED,
    is_uninitialized: () => ![ACCEPTED, REJECTED].includes(get_cookie(cookie_name)),
    set:              (acceptance) => set_cookie(cookie_name, acceptance, DURATION),
  };
}

const cookie_acceptance = {
  functional:             cookie_group_status_object('bw_cookies__strict__approved__functional'),
  statistical:            cookie_group_status_object('bw_cookies__strict__approved__statistical'),
  marketing:              cookie_group_status_object('bw_cookies__strict__approved__marketing'),
  default_banner_dismiss: cookie_group_status_object('bw_cookies__default__banner-dismissed'), // i.e: non gdpr mode
  legacy:                 cookie_group_status_object('cookies_approved'),

  uninitialized: () =>
    (cookie_acceptance.functional.is_uninitialized() ||
    cookie_acceptance.statistical.is_uninitialized() ||
    cookie_acceptance.marketing.is_uninitialized())  &&
    !cookie_acceptance.legacy.is_accepted(), // if legacy cookie has been accepted, don’t init the new system (can be removed after 12 months)

  gdpr_uninitalized: () =>
  (cookie_acceptance.functional.is_uninitialized() ||
  cookie_acceptance.statistical.is_uninitialized() ||
  cookie_acceptance.marketing.is_uninitialized()),

  set_all: (acceptance) => {
    cookie_acceptance.functional.set(acceptance);
    cookie_acceptance.statistical.set(acceptance);
    cookie_acceptance.marketing.set(acceptance);
  },

  ACCEPTED,
  REJECTED,
  DURATION,
};

export default cookie_acceptance;

